import { render, staticRenderFns } from "./MissionStatement.vue?vue&type=template&id=44f4beaf&scoped=true&"
import script from "./MissionStatement.vue?vue&type=script&lang=js&"
export * from "./MissionStatement.vue?vue&type=script&lang=js&"
import style0 from "./MissionStatement.vue?vue&type=style&index=0&id=44f4beaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f4beaf",
  null
  
)

export default component.exports